import { useValidationRules } from "@/iti-core-react/hooks/validation-rule-required-editors";
import { InfoPopOver } from "@/pages/Catalogue/components/InfoPopOver/InfoPopOver";
import DxTextBox from "devextreme-react/text-box";
import DxValidator from "devextreme-react/validator";
import {
	InitializedEvent,
	KeyDownEvent,
	ValueChangedEvent,
} from "devextreme/ui/text_box_types";
import { InitializedEvent as InitializedValidatorEvent } from "devextreme/ui/validator_types";
import { ItiString } from "../../utils/iti-string";
import "./ItiTextBox.scss";

interface ItiTextBoxProps {
	name?: string;
	label?: string;
	labelClass?: string;
	textBoxAttributes?: { [key: string]: any };
	width?: number | string;
	mode?: "text" | "email" | "password" | "search" | "tel" | "url";
	tabIndex?: number;
	stylingMode?: "outlined" | "underlined" | "filled";
	placeholder?: string;
	showClearButton?: boolean;
	readOnly?: boolean;
	disabled?: boolean;
	visible?: boolean;
	inputAttr?: any;
	value?: string;
	validationRules?: any;
	className?: string;
	mask?: string;
	useMaskedValue?: boolean;
	maskChar?: string;
	infoPopOverMessage?: any;
	infoPopOverClassName?: string;
	children?: any;
	maxLength?: number;
	customIniMask?: string;
	customIniMaskClass?: string;
	validationMessageMode?: "always" | "auto";
	onValueChanged?: (e: ValueChangedEvent) => void;
	saveTextBoxInstance?: (e: InitializedEvent) => void;
	onInitializedValidator?: (e: InitializedValidatorEvent) => void;
	onKeyDown?: (e: KeyDownEvent) => void;
}

export default function ItiTextBoxComponent({
	name,
	label,
	labelClass = "dx-field-item-label-text",
	textBoxAttributes = { class: "field-lg" },
	width,
	mode = "text",
	tabIndex,
	stylingMode = "outlined",
	placeholder,
	showClearButton = true,
	readOnly = false,
	disabled = false,
	visible = true,
	value,
	validationRules,
	className,
	mask,
	inputAttr = {},
	useMaskedValue = false,
	maskChar = "",
	onValueChanged,
	saveTextBoxInstance,
	onKeyDown,
	children,
	maxLength,
	customIniMask,
	customIniMaskClass = "font-size-mask",
	infoPopOverMessage,
	infoPopOverClassName,
	validationMessageMode = "always",
	onInitializedValidator,
}: Readonly<ItiTextBoxProps>) {
	const { isRequired } = useValidationRules(validationRules);

	function onFocusIn(e: any) {
		if (mask) {
			const input = e.element.querySelector(".dx-texteditor-input");
			setTimeout(() => {
				if (value) {
					input.selectionStart = value.length + 2;
					input.selectionEnd = value.length + 2;
				}
			});
		}
	}

	const getTextBox = () => {
		return (
			<DxTextBox
				maskChar={maskChar}
				name={name}
				mask={mask}
				useMaskedValue={useMaskedValue}
				className={className}
				elementAttr={textBoxAttributes}
				width={width}
				inputAttr={inputAttr}
				mode={mode}
				tab-index={tabIndex}
				stylingMode={stylingMode}
				placeholder={placeholder}
				showClearButton={showClearButton}
				readOnly={readOnly}
				disabled={disabled}
				visible={visible}
				value={value}
				maxLength={maxLength}
				validationMessageMode={validationMessageMode}
				onValueChanged={onValueChanged}
				onKeyDown={onKeyDown}
				onInitialized={saveTextBoxInstance}
				onFocusIn={onFocusIn}
			>
				<DxValidator
					validationRules={validationRules}
					onInitialized={onInitializedValidator}
				/>
				{children}
			</DxTextBox>
		);
	};

	return (
		<>
			{label && !ItiString.isNullOrWhiteSpace(label) && (
				<div className="d-flex align-items-center">
					<div className={labelClass}>{label + (isRequired ? "*" : "")}</div>
					{infoPopOverMessage && (
						<InfoPopOver
							message={infoPopOverMessage}
							classNameInfo={infoPopOverClassName}
						/>
					)}
				</div>
			)}

			{customIniMask ? (
				<div className={`row align-items-center ${customIniMaskClass}`}>
					<div className="col-auto p-0 m-0">{customIniMask}</div>

					<div className="col ps-0 ms-1">{getTextBox()}</div>
				</div>
			) : (
				getTextBox()
			)}
		</>
	);
}
